import ClearSlideImg from "../../images/ClearSlide.svg";
const ClearSlide = ({ editor }) => {
  const clearSlideContent = () => {
    editor.DomComponents.getComponents().at(0).empty();
    editor.select(editor.DomComponents.getComponents().at(0));
   /* editor.DomComponents.clear();
   // editor.DomComponents.getWrapper().set("content", "");
    editor.addComponents({
    tagName: 'div',
    attributes: { 'data-gjs-editable': 'true', 'data-gjs-draggable': 'true', 'data-gjs-name':'Wrapper' ,'id':"wrapper"},
   // style: {   width: "1024px", position:"absolute", height: "768px", }
    });
    if (editor.DomComponents.getComponents()?.at(0)?.ccid === "wrapper" ) {
          editor.DomComponents.getComponents().at(0).set({ name: "Wrapper" ,  selectable: true});
      } */
  };
  return (
    <>
      <div
        onClick={() => clearSlideContent()}
        className="d-flex align-items-center"
      >
        <img src={ClearSlideImg} alt="clone Slide" className="ignoreClick" />
        <h2>Clear Slide</h2>
      </div>
    </>
  );
};
export default ClearSlide;
